import PropTypes from 'prop-types';

KTOverlay.propTypes = {
  wrapperEl: PropTypes.element.isRequired,
  layerEl: PropTypes.element.isRequired,
  additionalWrapperClass: PropTypes.string,
  additionalLayerClass: PropTypes.string,
  enableBlock: PropTypes.bool,
};

function KTOverlay({
  wrapperEl,
  layerEl,
  additionalWrapperClass = '',
  additionalLayerClass = '',
  enableBlock = false,
}) {
  return (
    <div className={`overlay h-100 ${enableBlock ? 'overlay-block' : ''}`}>
      <div className={`overlay-wrapper ${additionalWrapperClass}`}>{wrapperEl}</div>
      <div className={`overlay-layer ${additionalLayerClass}`}>{layerEl}</div>
    </div>
  );
}

export default KTOverlay;
